module.exports = __webpack_public_path__ + "static/media/LightningLight.bba65411.svg";